import { WARING_DAYS } from "constants/AppConstants";
import React from "react";
import Icon from "../UI/Icon/Icon";
import { sanitizeStrict } from "../../utils/htmlSanitizer";

interface ApplicationSummaryProps {
  applicationReceivedOn: string | null | undefined;
  primaryTenants: any[];
  tenantPropertyAddress: string | null | undefined;
  formatTenantList: (tenants: any[]) => string;
  daysLeft?: number;
  approvalText?: string;
}

const ApplicationSummary: React.FC<ApplicationSummaryProps> = ({
  applicationReceivedOn,
  primaryTenants,
  tenantPropertyAddress,
  formatTenantList,
  daysLeft = 1,
  approvalText = "automatic approval without conditions",
}) => {
  return (
    <div className="border border-grey-3 p-20px radius-5px drop-shadow d-flex flex-column gap-20px">
      <div className="bg-off-white p-10px radius-5px min-h-70px d-flex flex-column flex-md-row gap-10px align-items-md-center justify-content-md-between">
        <div className="d-flex gap-10px align-items-center w-100">
          <div className="px-10px d-none d-md-block">
            <Icon name="personID" size={30} />
          </div>
          <div className="d-flex flex-column gap-15px gap-md-3px text-black text-break">
            <div className="d-flex flex-column flex-md-row gap-3px gap-md-10px">
              <div className="fs-18px fw-bold">Date Received:</div>
              <div className="fs-16px">{applicationReceivedOn}</div>
            </div>
            <div className="d-flex flex-column flex-md-row gap-3px gap-md-10px">
              <div className="fs-18px fw-bold">Tenant/s:</div>
              <div className="d-flex flex-column">
                <div className="fs-16px">
                  <span dangerouslySetInnerHTML={{ __html: sanitizeStrict(formatTenantList(primaryTenants || [])) }} />
                </div>
              </div>
            </div>
            <div className="d-flex flex-column flex-md-row gap-3px gap-md-10px">
              <div className="fs-18px fw-bold">Rental Property:</div>
              <div className="fs-16px">{tenantPropertyAddress}</div>
            </div>
          </div>
        </div>
        <div className="min-w-256px w-256px px-md-10px d-flex gap-3px align-items-center">
          <Icon name="hourglass" color={`${daysLeft <= WARING_DAYS ? "red" : "black"}`} className="min-w-24px" />
          <div className="fs-16px">
            <span className={`${daysLeft <= WARING_DAYS ? "text-red" : "text-black"} fw-bold`}>{daysLeft} day{daysLeft !== 1 ? 's' : ''} left</span> until
            {" "}
            {approvalText}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationSummary;